export default "__VITE_ASSET__CqOiG4Di__"